import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { WishlistServiceProvider } from '../../providers/wishlist-service/wishlist-service';
import { WishlistAdd, WishlistRemove, WishlistGet } from '../../models/models';
import { LocationServiceProvider } from '../../providers/location-service/location-service';
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AppEventService } from '../../app/app-events';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the WishlistButtonComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'wishlist-button',
  templateUrl: 'wishlist-button.html',
  styleUrls: ['./wishlist-button.scss'],
  standalone: false,
  // imports: [
  //   IonicModule,
  //   CommonModule,
  //   FormsModule,
  //   TranslateModule
  // ]
})
export class WishlistButtonComponent implements OnInit, OnDestroy, AfterViewInit {

  updateWishlistSubscription;
  imgSource: string;
  added: boolean;
  _beerID: string;

  @Input()
  set beerID(bID: string) {
    //debugger;
    this._beerID = bID;
    this.checkIfInWishlist();
  }
  get beerID() {
    return this._beerID;
  }

  constructor(
    private wishlistService: WishlistServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private locationProvider: LocationServiceProvider,
    private events: AppEventService,
    private bhutil: BhutilProvider
  ) {
    this.imgSource = 'assets/svg/icon_wishlist_plus.svg';
    this.added = false;

    //this.checkIfInWishlist();

  }

  ngOnInit() {
    this.updateWishlistSubscription = () => {
      this.checkIfInWishlist();
    }
    this.events.subscribe("beer-detail:update:wislist-button", this.updateWishlistSubscription);
  }
  ngOnDestroy() {
    this.events.unsubscribe("beer-detail:update:wislist-button", this.updateWishlistSubscription);
  }
  ngAfterViewInit() {
    this.checkIfInWishlist();
  }

  //check if this beer is already in the wishlist
  checkIfInWishlist() {

    console.log("[wishlist-button] checkIfInWishlist for beer_id " + this.beerID);

    this.userData.getUserID()
      .then((userID) => {
        //debugger;
        let wishlistID = "B:" + this.beerID + "-U:" + userID;
        console.log("[wishlist-button] checking if item " + wishlistID + " is already in the wishlist of this user");

        let count = 100;
        let page = 1;
        let wishlistGet = new WishlistGet(userID, this.locationProvider.latitude, this.locationProvider.longitude, count, page, "", "", null);

        console.dir("[wishlist-button] WISHLIST - wishlist get for userID " + userID);
        console.dir(wishlistGet);

        this.wishlistService.getWishList(wishlistGet).subscribe(
          resp => {
            //console.log("[wishlist-button] [WISHLIST][GET] - response for wishlist get"/* + this.bhutil.stringify(resp)*/);

            let wishlistItems = resp;
            let listed: boolean = false;
            let wishlistItemIndex: any;
            let wishlistItem: any;

            for (wishlistItemIndex in wishlistItems) {
              wishlistItem = wishlistItems[wishlistItemIndex];
              if (wishlistItem.id === wishlistID) {
                listed = true;
              }
            }

            if (listed) {
              console.log("[wishlist-button] beer " + this.beerID + " is in the wishlist!");
              this.added = true;
              this.imgSource = 'assets/svg/icon_wishlist_minus.svg';
              this.events.publish("wishlist:present", true);
            }
            else {
              console.log("[wishlist-button] beer " + this.beerID + " is not in the wishlist...");
              this.added = false;
              this.imgSource = 'assets/svg/icon_wishlist_plus.svg';
              this.events.publish("wishlist:present", false);
            }
          },
          err => {
            //debugger;
            console.log(err)
          });
      })
      .catch((e) => {
        console.log("[wishlist-button][addToWishlist] failed => " + e);
      });
  }

  addToWishlist() {
    let caller = this;
    if (!this.added) {
      console.log("[wishlist-button][add to wishlist] - beerID " + this.beerID);
      //this.imgSource = 'assets/svg/icon_wishlist_minus.svg';

      //API call
      this.userData.getUserID()
        .then((userID) => {
          //debugger;
          let wishlistAdd: WishlistAdd = new WishlistAdd(userID, this.locationService.latitude, this.locationService.longitude, this.beerID);
          this.wishlistService.addToWishlist(wishlistAdd).subscribe(resp => {
            console.log("[wishlist-button] Resp for addToWishlist: " + this.bhutil.stringify(resp));
            caller.imgSource = 'assets/svg/icon_wishlist_minus.svg';

            caller.events.publish("wishlist:present", true);

            //this.beerCount = resp.beercount;
            //this.breweryCount = resp.brewerycount;
            //this.analysisCount = resp.myanalysescount;

          }, err => console.log("[wishlist-button] add to wishlist ERROR: " + err));;
        })
        .catch((e) => {
          console.log("[wishlist-button][addToWishlist] failed => " + e);
        });
    }
    else {
      console.log("[wishlist-button][remove from wishlist] - beerID " + this.beerID);
      //this.imgSource = 'assets/svg/icon_wishlist_plus.svg';

      //API call
      this.userData.getUserID()
        .then((userID) => {
          //debugger;
          let wishtlistRemove: WishlistRemove = new WishlistRemove(userID, this.locationService.latitude, this.locationService.longitude, this.beerID);
          this.wishlistService.removeFromWishlist(wishtlistRemove).subscribe(resp => {
            console.log("[wishlist-button] Resp for removeFromWishlist: " + this.bhutil.stringify(resp));
            caller.imgSource = 'assets/svg/icon_wishlist_plus.svg';
            caller.events.publish("wishlist:present", false);

            //this.beerCount = resp.beercount;
            //this.breweryCount = resp.brewerycount;
            //this.analysisCount = resp.myanalysescount;

          }, err => console.log("remove from wishlist ERROR: " + err.error));;
        })
        .catch((e) => {
          console.log("[wishlist-button][removeFromWishlist] failed => " + e);
        });


    }
    this.added = !this.added;
  }

}
